import React from 'react';
import { OptionColorsSkeleton } from '../Skeleton/OptionColors.Skeleton';
import { AddButtonWrapperSkeleton } from '../Skeleton/AddButtonWrapper.Skeleton';
import { MEDIA_BREAKPOINTS } from '../../../../../constants/MEDIA_BREAKPOINTS';
export const TilesFormSkeleton = () => (React.createElement("div", null,
    React.createElement(OptionColorsSkeleton, { nbItems: 3 }),
    MEDIA_BREAKPOINTS.LG_UP.matches &&
        React.createElement(AddButtonWrapperSkeleton, null)));
